import { Customer } from "gen/customer/models_pb"
import { useMemo } from "react"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useSearchCustomersV2 } from "features/api/search"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export function useCustomerFilter({
  key = "customer",
  persistInUrl = true,
  initialSelectedOptions = [],
}: Partial<
  Pick<
    UseWebFilterProps<unknown>,
    "persistInUrl" | "key" | "initialSelectedOptions"
  >
> = {}) {
  const { results, setQuery, loadNext } = useSearchCustomersV2()

  const customers = useMemo(() => {
    const res: Customer[] = []
    for (const { customer } of results) {
      if (!customer) continue
      res.push(customer)
    }
    return res
  }, [results])

  const { filter, selected: selectedCustomerIds } = useIdFilter({
    key,
    label: "Customer",
    values: customers,
    labelExtractor: (customer) => customer.name,
    onChangeQuery: setQuery,
    autoFilterOptions: false,
    allowExternalValues: true,
    onLoadMore: loadNext,
    useFilter: (props) => {
      return useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      })
    },
  })

  return { filter, selectedCustomerIds }
}
